import { useContext, useState } from "react";
import VisibilityContext from "src/provider/state-manager/visibilityProvider";
import {
  AbsoluteContainer,
  AppText,
  Button,
  CustomContainer,
  FixedContainer,
  FlexRow,
  GridContainer,
  ScreenTitle,
} from "src/style";
import successGif from "src/assets/gif/success.json";
import successConfetti from "src/assets/gif/successConfetti.json";
import Lottie from "lottie-react";
import { RiCloseFill } from "react-icons/ri";

interface AlertProps {
  title: string;
  body: string;
  close: () => void;
  next: () => void;
}
const AlertModal = ({ title, body, close, next }: AlertProps) => {
  return (
    <FixedContainer
      height="full"
      width="100"
      sizeUnit="%"
      top="0"
      left="0"
      zIndex="15"
    >
      <GridContainer
        width="100"
        sizeUnit="%"
        height="100"
        hUnit="%"
        bgColor="rgba(0,0,0, 0.3)"
        onClick={close}
      >
        <CustomContainer
          width="40"
          minHeight="22"
          radius="1"
          bgColor="#ffffff"
          padding="2"
          topPadding="1"
          overflow="auto"
          shadow="0px 24px 56px rgba(0, 23, 69, 0.04)"
          className={`popup-main-container popup-main-container-d2`}
          onClick={(e) => e.stopPropagation()}
        >
          <FlexRow justifyContent="flex-end" bottomMargin="0.5">
            <Button
              titleSize="2"
              fontWeight="500"
              width="3.4"
              shadow="none"
              height="3.4"
              radius="0.6"
              bgColor="#ffffff"
              hoverBgColor="#FEF3F2"
              borderColor="none"
              color="#000000"
              hoverColor="#B42318"
              onClick={close}
            >
              <RiCloseFill fontSize="2.3rem" />
            </Button>
          </FlexRow>

          <CustomContainer className="popup-content-container">
            <GridContainer>
              <ScreenTitle
                textSize="2.2"
                fontWeight="700"
                align="center"
                topMargin="0.5"
                fontFamily="Gilmer-Bold"
              >
                {title}
              </ScreenTitle>

              <AppText>{body}</AppText>

              <Button
                width="100"
                sizeUnit="%"
                height="4.4"
                topMargin="2.5"
                borderColor="#0D968F"
                hoverBgColor="#ffffff"
                hoverColor="#0D968F"
                titleSize="1.4"
                onClick={next}
              >
                Continue
              </Button>
            </GridContainer>
          </CustomContainer>
        </CustomContainer>
      </GridContainer>
    </FixedContainer>
  );
};

export default AlertModal;
